import { IUser } from 'interfaces/models.interface'
import { IAuthContext } from 'interfaces/utils.interface'
import { useCallback, useMemo, useState } from 'react'
import { loggerService, profileService, storageService, transformerService } from 'services'

export function useProvideAuth(): IAuthContext {
  const getAccessToken = useCallback((): string | null => {
    return storageService.getAccessToken()
  }, [])

  const getRefreshToken = useCallback((): string | null => {
    return storageService.getRefreshToken()
  }, [])
  const getChangeToken = useCallback((): string | null => {
    return storageService.getChangeToken()
  }, [])

  const removeTokens = useCallback(() => {
    storageService.removeTokens()
    setChangeToken(undefined)
  }, [])

  const getUserData = useCallback((): IUser | undefined => {
    const token = storageService.getAccessToken() //TODO: verificare se usare una chiamata al BE prima di leggere il token
    if (!!token) {
      try {
        const tokenParts = token.split('.')
        const encodedTokenData = tokenParts[1]
        const data = atob(encodedTokenData)
        return transformerService.fromTokenToIUser(data)
      } catch (error) {
        loggerService.error('ERROR WHILE TRASFORMING TOKEN', error)
      }
    }
  }, [])

  const [user, setUser] = useState<IUser | undefined>(getUserData())
  const saveTokens = useCallback(
    (accessToken?: string | null, refreshToken?: string | null, changeToken?: string | null) => {
      storageService.saveTokens(accessToken, refreshToken, changeToken)
      setUser(getUserData())
    },
    [getUserData, setUser],
  )

  const [changeToken, setChangeToken] = useState<string | undefined | null>(getChangeToken())

  const login = useCallback(
    (username: string, password: string, onSuccess: Function, onError: Function): AbortController => {
      return profileService.login(
        username,
        password,
        (accessToken, refreshToken, changeToken) => {
          saveTokens(accessToken, refreshToken, changeToken)
          if (!changeToken) {
            const userData = getUserData()
            setUser(userData)
            onSuccess()
          }

          setChangeToken(changeToken)
        },
        (error) => {
          onError(error)
        },
      )
    },
    [getUserData, saveTokens],
  )

  const logout = useCallback(
    (onSuccess: Function) => {
      removeTokens()
      setUser(undefined)
      window.location.href = '/login'
    },
    [removeTokens],
  )

  const result = useMemo(() => {
    return {
      user,
      changeToken,
      login,
      logout,
      getUserData,
      getAccessToken,
      getRefreshToken,
      getChangeToken,
      saveTokens,
      removeTokens,
      setUser,
    }
  }, [user, login, logout, getUserData, getAccessToken, getRefreshToken, saveTokens, removeTokens, changeToken, getChangeToken, setUser])

  return result
}
